var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, ElementRef, EventEmitter, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HasSubscriptions } from '../../has-subscriptions';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms'; // kanew
import { emailRegex, LeadTrigger, LeadType } from '../../../classes/leads';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { HOME_ESTIMATOR_CONSULT_AN_AGENT, SITE_SEARCH, SITE_SEARCH_TERM } from '../../../classes/analytics-tags';
import { GoogleMapsService } from '../../../services/google-maps.service';
import { PreferencesService } from '../../../services/preferences.service';
import { SearchResult } from '../../search-bar/search-bar.component';
import { Angulartics2 } from 'angulartics2';
import { ErrorKey, ErrorService } from '../../../services/error.service';
import { LeadsService } from '../../../services/leads.service';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../../classes/dynamicScripts';
import { isNullOrUndefined } from 'util';
var HomeEstimatorLeadFormComponent = /** @class */ (function (_super) {
    __extends(HomeEstimatorLeadFormComponent, _super);
    function HomeEstimatorLeadFormComponent(document, sanitizer, analyticsService, preferencesService, domManipulationService, googleService, cdRef, angulartics2, errorService, leadsService, translateService) {
        var _this = _super.call(this) || this;
        _this.document = document;
        _this.sanitizer = sanitizer;
        _this.analyticsService = analyticsService;
        _this.preferencesService = preferencesService;
        _this.domManipulationService = domManipulationService;
        _this.googleService = googleService;
        _this.cdRef = cdRef;
        _this.angulartics2 = angulartics2;
        _this.errorService = errorService;
        _this.leadsService = leadsService;
        _this.translateService = translateService;
        _this.locationResults = [];
        _this.showAdditionalActionsButtons = false;
        _this.showSearchResults = false;
        _this.focus = false;
        _this.showRequestSent = false;
        _this.isSearching = false;
        _this.recentSearches = [];
        _this.newSet = [];
        _this._radiusForSearchBias = 50000; // in meters
        _this._maxLocationResults = 3;
        _this.showRequestSentEvent = new EventEmitter();
        _this.homeEstimatorForm = new FormGroup({
            userName: new FormControl(''),
            userEmail: new FormControl('', { validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'change' }),
            userAddress: new FormControl('', [Validators.required])
        });
        return _this;
    }
    Object.defineProperty(HomeEstimatorLeadFormComponent.prototype, "nameInput", {
        get: function () {
            return this.homeEstimatorForm.controls.userName.value;
        },
        set: function (value) {
            this.homeEstimatorForm.controls.userName.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeEstimatorLeadFormComponent.prototype, "emailInput", {
        get: function () {
            return this.homeEstimatorForm.controls.userEmail.value;
        },
        set: function (value) {
            this.homeEstimatorForm.controls.userEmail.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeEstimatorLeadFormComponent.prototype, "addressInput", {
        get: function () {
            return this.homeEstimatorForm.controls.userAddress.value;
        },
        set: function (value) {
            this.homeEstimatorForm.controls.userAddress.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    HomeEstimatorLeadFormComponent.prototype.ngOnInit = function () {
        this.setVideoUrl();
        this.watchAddressInput();
        this.watchPositionInfo();
        if (this.email) {
            this.homeEstimatorForm.controls['email'].setValue(this.email);
        }
    };
    HomeEstimatorLeadFormComponent.prototype.setVideoUrl = function () {
        this.videoUrl = this.getVideoUrl();
    };
    HomeEstimatorLeadFormComponent.prototype.getVideoUrl = function () {
        return this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/cxdQmZQBu6o?rel=0');
    };
    HomeEstimatorLeadFormComponent.prototype.watchAddressInput = function () {
        var _this = this;
        this.addSub(this.homeEstimatorForm.get('userAddress').valueChanges
            .pipe(debounceTime(200))
            .pipe(filter(function (searchInput) {
            if (!searchInput || !_this.locationLatLng) {
                _this._resetResults();
                return false;
            }
            return true;
        }))
            .pipe(switchMap(function (searchInput) { return _this._getQueryPredictionsSearch(searchInput); }))
            .subscribe(function (x) {
            if (x) {
                _this.locationResults = x.map(function (e) { return new SearchResult(e.description, e.description, 'location'); });
            }
            else {
                _this.locationResults = null;
            }
            _this.isSearching = false;
            _this.cdRef.detectChanges();
        }));
    };
    HomeEstimatorLeadFormComponent.prototype._resetResults = function () {
        this.locationResults = [];
    };
    HomeEstimatorLeadFormComponent.prototype._getQueryPredictionsSearch = function (searchInput) {
        this.isSearching = true;
        this.analyticsService.eventTrack(SITE_SEARCH, (_a = {}, _a[SITE_SEARCH_TERM] = searchInput, _a));
        return this.googleService.getPlacePredictions(searchInput, new google.maps.LatLng(this.locationLatLng.lat, this.locationLatLng.lng), this._radiusForSearchBias);
        var _a;
    };
    HomeEstimatorLeadFormComponent.prototype.watchPositionInfo = function () {
        var _this = this;
        this.addSub(this.preferencesService.positionInfoChanged.subscribe(function (position) {
            if (position.centerLatLng) {
                _this.locationLatLng = {
                    lat: position.centerLatLng.lat,
                    lng: position.centerLatLng.lng
                };
            }
        }));
    };
    HomeEstimatorLeadFormComponent.prototype.isFormControlValid = function (control) {
        return !(control.invalid && (control.dirty || control.touched));
    };
    Object.defineProperty(HomeEstimatorLeadFormComponent.prototype, "userName", {
        get: function () {
            return this.homeEstimatorForm.get('userName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeEstimatorLeadFormComponent.prototype, "userEmail", {
        get: function () {
            return this.homeEstimatorForm.get('userEmail');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeEstimatorLeadFormComponent.prototype, "userAddress", {
        get: function () {
            return this.homeEstimatorForm.get('userAddress');
        },
        enumerable: true,
        configurable: true
    });
    HomeEstimatorLeadFormComponent.prototype.sendGrecaptcha = function () {
        var _this = this;
        this.addSub(this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(function () {
            grecaptcha.execute(_this.recaptchaId);
        }));
    };
    HomeEstimatorLeadFormComponent.prototype.onAddressInputClick = function () {
        this._getQueryPredictions();
        this.showSearchResults = true;
    };
    HomeEstimatorLeadFormComponent.prototype._getQueryPredictions = function () {
        if (!!this.addressInput) {
            this._getQueryPredictionsSearch(this.addressInput);
        }
        else
            this._resetResults();
    };
    HomeEstimatorLeadFormComponent.prototype.getOnSubmit = function () {
        return this.onSubmit.bind(this);
    };
    HomeEstimatorLeadFormComponent.prototype.onSubmit = function (recaptchaKey) {
        var _this = this;
        this.googleService.performGeocode(this.addressInput).then(function (results) {
            if (results[0].address_components.length === 1 || results[0].address_components.findIndex(function (g) { return g.short_name.toLowerCase() === 'qc'; }) !== -1) {
                _this.homeEstimatorForm.controls['userAddress'].setErrors({ 'incorrect': true });
                _this.homeEstimatorForm.controls['userAddress'].setValue('');
                _this.homeEstimatorForm.updateValueAndValidity({ onlySelf: true });
                return;
            }
            var address = results[0].address_components;
            _this.address = results[0].formatted_address;
            var postalCode = address.find(function (g) { return g.types.includes('postal_code'); });
            var city = address.find(function (g) { return g.types.includes('locality'); });
            var province = address.find(function (g) { return g.types.includes('administrative_area_level_1'); });
            _this.postalCode = postalCode ? postalCode.long_name : null;
            _this.city = city ? city.long_name : null;
            _this.province = province ? province.short_name : null;
            var leadBody = _this.constructTheLeadObject();
            _this.leadsService.sendLead(leadBody, recaptchaKey)
                .then(function () {
                _this.sendAnalyticsEvent();
                _this.homeEstimatorForm.reset();
                _this.showRequestSentEvent.emit();
            })
                .catch(function (err) {
                _this.errorService.displayError(ErrorKey.lead, err.error.errorCode, 30);
            });
        });
    };
    HomeEstimatorLeadFormComponent.prototype.constructTheLeadObject = function () {
        var leadBody = {
            leadType: LeadType.HVEGeneric,
            triggerType: LeadTrigger.Generic,
            contactInfo: {
                name: this.nameInput,
                email: this.emailInput,
                postalCode: this.postalCode,
                city: this.city,
                province: this.province,
            },
            contactPref: {
                email: true,
            },
            comments: this.translateService.instant("contact.home-estimator-form", { address: this.address })
        };
        return leadBody;
    };
    HomeEstimatorLeadFormComponent.prototype.sendAnalyticsEvent = function () {
        var tagName = HOME_ESTIMATOR_CONSULT_AN_AGENT;
        this.angulartics2.eventTrack.next({
            properties: {
                event: tagName
            }
        });
    };
    HomeEstimatorLeadFormComponent.prototype.onLoseFocus = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.addressBarRef.nativeElement.contains(_this.document.activeElement))
                _this.showSearchResults = false;
            // [MBL-3080] Added the following functionality to check if address autocomplete is selected otherwise clear the input to start fresh...
            if (!isNullOrUndefined(_this.locationResults)) {
                Object.entries(_this.locationResults).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.newSet.push(_this.locationResults[key].text.toLowerCase());
                });
                if (!_this.newSet.includes(_this.addressInput.toLowerCase())) {
                    _this.homeEstimatorForm.controls['userAddress'].setErrors({ 'incorrect': true });
                    _this.homeEstimatorForm.controls['userAddress'].setValue('');
                    _this.homeEstimatorForm.updateValueAndValidity({ onlySelf: true });
                    _this.triggerValidation(_this.homeEstimatorForm);
                }
                else {
                    _this.homeEstimatorForm.controls['userAddress'].setErrors({ 'incorrect': null });
                    _this.homeEstimatorForm.controls['userAddress'].updateValueAndValidity({ onlySelf: true });
                    _this.homeEstimatorForm.updateValueAndValidity({ onlySelf: true });
                    _this.triggerValidation(_this.homeEstimatorForm);
                }
            }
            else {
                _this.homeEstimatorForm.controls['userAddress'].setErrors({ 'incorrect': true });
                _this.homeEstimatorForm.controls['userAddress'].setValue('');
                _this.homeEstimatorForm.updateValueAndValidity({ onlySelf: true });
                _this.triggerValidation(_this.homeEstimatorForm);
            }
        });
    };
    HomeEstimatorLeadFormComponent.prototype.triggerValidation = function (control) {
        if (control instanceof FormGroup) {
            var group = control;
            for (var field in group.controls) {
                var c = group.controls[field];
                this.triggerValidation(c);
            }
        }
        else if (control instanceof FormArray) {
            var group = control;
            for (var field in group.controls) {
                var c = group.controls[field];
                this.triggerValidation(c);
            }
        }
        control.updateValueAndValidity({ onlySelf: false });
    };
    HomeEstimatorLeadFormComponent.prototype.onSelectResult = function ($event) {
        this.addressInput = $event.data;
        this.showSearchResults = false;
        this.focus = false;
    };
    return HomeEstimatorLeadFormComponent;
}(HasSubscriptions));
export { HomeEstimatorLeadFormComponent };
